import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Button, LoadingBubbles, Text,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import type { ArtworkPageDataChange } from '@domain-group/realhub-backend-api-types'

import type { UseArtworkDataChangesPayload } from '@hooks/useArtworkDataChanges'

const defaultState = {
  updating: false,
}

interface ChangeProps {
  artworkPageId: number,
  callbacks: {
    syncDataChanges: UseArtworkDataChangesPayload['callbacks']['syncDataChanges'],
  },
  change: ArtworkPageDataChange,
  disableSync?: boolean,
}

const Change = (props: ChangeProps) => {
  const {
    artworkPageId,
    callbacks: {
      syncDataChanges,
    },
    change: {
      artwork_data_key,
      current_value,
      id,
      new_value,
      patch,
      placeholder,
    },
    disableSync = false,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { updating } = state

  const syncDataChange = () => {
    setState({ updating: true })

    const mappedChanges = [
      {
        artwork_page_id: artworkPageId,
        artwork_data_key,
        id,
        patch,
      },
    ]

    syncDataChanges(mappedChanges)
  }

  return (
    <Box flexDirection="column" marginTop="large">
      <Box alignItems="center" justifyContent="space-between">
        <Text fontSize="xsmall" fontWeight="bold">
          {placeholder}
        </Text>

        {!disableSync && (
          <Button
            buttonStyle={updating ? 'primaryCreate' : 'secondaryCreate'}
            // @ts-expect-error TS2322
            ghost={!updating}
            icon={updating ? <LoadingBubbles color="#ffffff" /> : <FontAwesomeIcon icon={faSync} />}
            size="tiny"
            onClick={() => syncDataChange()}
            width="auto"
          >
            Sync
          </Button>
        )}
      </Box>

      <Box
        backgroundColor="#FFEEF0"
        borderRadius={5}
        fontSize="xsmall"
        marginTop="small"
        paddingX="medium"
        paddingY="medium"
      >
        {current_value || <i>No Value</i>}
      </Box>

      <Box
        backgroundColor="#F8F8F8"
        borderRadius={5}
        fontSize="xsmall"
        marginTop="small"
        paddingX="medium"
        paddingY="medium"
      >
        {new_value || <i>No Value</i>}
      </Box>
    </Box>
  )
}

export default Change
